import { contactInfo } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-500">投稿、合作、反馈，我们期待您的联系</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8">
            <h3 className="font-heading text-xl text-foreground-950 mb-4">{contactInfo.title}</h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {contactInfo.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-500">电子邮箱</div>
                  <div className="text-sm text-foreground-800 font-medium truncate">{contactInfo.email}</div>
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-qq-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-500">QQ客服</div>
                  <div className="text-sm text-foreground-800 font-medium">{contactInfo.qq}</div>
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 flex-shrink-0">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-xs text-foreground-500">微信客服</div>
                  <div className="text-sm text-foreground-800 font-medium">{contactInfo.wechat}</div>
                </div>
              </div>
            </div>

            <div className="flex items-start gap-2 p-3 bg-secondary-50 rounded-lg">
              <i className="ri-information-line text-secondary-600 mt-0.5 flex-shrink-0"></i>
              <p className="text-xs md:text-sm text-foreground-600">{contactInfo.tips}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}